module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Fan-3efc50045c2707a1ccc0faaf415c1eb5.svg";